import { useEffect, useState } from "react";
import axios from "axios";

const base_url = process.env.REACT_APP_API_URL;

export default function CallbackHistory() {
    const token = localStorage.getItem("admin_token");

    const [loading, setLoading] = useState(false);

    const [data, setData] = useState([]);
    const [gameSummary, setGameSummary] = useState([]);
    const [showPayload, setShowPayload] = useState(false);
    const [showResponse, setShowResponse] = useState(false);
    const [payloadModal, setPayloadModal] = useState("");
    const [responseModal, setResponseModal] = useState("");

    const [summary, setSummary] = useState({
        totalCallback: 0,
        success: 0,
        failed: 0,
        placed: 0,
        win: 0,
        refund: 0,
        totalBet: 0,
        totalWin: 0,
        totalProfit: 0,
    });

    const [page, setPage] = useState(1);

    const [totalPages, setTotalPages] = useState(1);

    // ---------------- Filters ----------------

    const [search, setSearch] = useState("");

    const [clientId, setClientId] = useState("");

    const [gameName, setGameName] = useState("");

    const [status, setStatus] = useState("");

    const [callbackStatus, setCallbackStatus] =
        useState("");

    const [fromDate, setFromDate] = useState("");

    const [toDate, setToDate] = useState("");

    const formatJson = (value) => {
  if (!value) return "No Data";

  try {
    // Already an object
    if (typeof value === "object") {
      return JSON.stringify(value, null, 2);
    }

    // JSON string
    return JSON.stringify(JSON.parse(value), null, 2);
  } catch (e) {
    return String(value);
  }
};

    // ============================================
    // Fetch Data
    // ============================================

    const fetchHistory = async (
        currentPage = page,
        currentSearch = search,
        currentClient = clientId,
        currentGame = gameName,
        currentStatus = status,
        currentCallback = callbackStatus,
        currentFrom = fromDate,
        currentTo = toDate
    ) => {
        try {
            setLoading(true);

            const res = await axios.get(
                `${base_url}/api/admin/callback-history`,
                {
                    params: {
                        page: currentPage,
                        limit: 20,
                        search: currentSearch,
                        client_id: currentClient,
                        game_name: currentGame,
                        status: currentStatus,
                        callback_status: currentCallback,
                        fromDate: currentFrom,
                        toDate: currentTo,
                    },
                    headers: {
                        Authorization: token,
                    },
                }
            );

            if (res.data.success) {
                setData(res.data.data);

                setSummary(res.data.summary);

                setGameSummary(
                    res.data.gameSummary || []
                );

                setPage(
                    res.data.pagination.page
                );

                setTotalPages(
                    res.data.pagination.totalPages
                );
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    // ============================================
    // First Load
    // ============================================

    useEffect(() => {
        fetchHistory();
    }, []);

    // ============================================
    // Search
    // ============================================

    const handleSearch = (e) => {
        const value = e.target.value;

        setSearch(value);

        fetchHistory(
            1,
            value,
            clientId,
            gameName,
            status,
            callbackStatus,
            fromDate,
            toDate
        );
    };

    // ============================================
    // Client
    // ============================================

    const handleClient = (e) => {
        const value = e.target.value;

        setClientId(value);

        fetchHistory(
            1,
            search,
            value,
            gameName,
            status,
            callbackStatus,
            fromDate,
            toDate
        );
    };

    // ============================================
    // Game
    // ============================================

    const handleGame = (e) => {
        const value = e.target.value;

        setGameName(value);

        fetchHistory(
            1,
            search,
            clientId,
            value,
            status,
            callbackStatus,
            fromDate,
            toDate
        );
    };

    // ============================================
    // Status
    // ============================================

    const handleStatus = (e) => {
        const value = e.target.value;

        setStatus(value);

        fetchHistory(
            1,
            search,
            clientId,
            gameName,
            value,
            callbackStatus,
            fromDate,
            toDate
        );
    };

    // ============================================
    // Callback Status
    // ============================================

    const handleCallbackStatus = (e) => {
        const value = e.target.value;

        setCallbackStatus(value);

        fetchHistory(
            1,
            search,
            clientId,
            gameName,
            status,
            value,
            fromDate,
            toDate
        );
    };

    // ============================================
    // From Date
    // ============================================

    const handleFromDate = (e) => {
        const value = e.target.value;

        setFromDate(value);

        fetchHistory(
            1,
            search,
            clientId,
            gameName,
            status,
            callbackStatus,
            value,
            toDate
        );
    };

    // ============================================
    // To Date
    // ============================================

    const handleToDate = (e) => {
        const value = e.target.value;

        setToDate(value);

        fetchHistory(
            1,
            search,
            clientId,
            gameName,
            status,
            callbackStatus,
            fromDate,
            value
        );
    };

    // ============================================
    // Pagination
    // ============================================

    const nextPage = () => {
        if (page < totalPages) {
            fetchHistory(
                page + 1,
                search,
                clientId,
                gameName,
                status,
                callbackStatus,
                fromDate,
                toDate
            );
        }
    };

    const prevPage = () => {
        if (page > 1) {
            fetchHistory(
                page - 1,
                search,
                clientId,
                gameName,
                status,
                callbackStatus,
                fromDate,
                toDate
            );
        }
    };

    // ============================================
    // Badge
    // ============================================

    const callbackBadge = (value) => {
        if (value === "success") {
            return (
                <span className="badge bg-success">
                    Success
                </span>
            );
        }

        return (
            <span className="badge bg-danger">
                Failed
            </span>
        );
    };

    const statusBadge = (value) => {
        if (value === "placed") {
            return (
                <span className="badge bg-primary">
                    Placed
                </span>
            );
        }

        if (value === "win") {
            return (
                <span className="badge bg-success">
                    Win
                </span>
            );
        }

        return (
            <span className="badge bg-warning text-dark">
                Refund
            </span>
        );
    };

    return (
        <div className="container-fluid py-3">
            <h3 className="fw-bold mb-3">
                Callback History
            </h3>

            {/* Part 2 starts here */}
            {/* ==========================================================
    Filters
========================================================== */}

            <div className="card shadow-sm border-0 mb-4">
                <div className="card-body">

                    <div className="row g-3">

                        {/* Search */}

                        <div className="col-md-3">
                            <label className="form-label fw-semibold">
                                Phone / UID
                            </label>

                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search Phone or UID"
                                value={search}
                                onChange={handleSearch}
                            />
                        </div>

                        {/* Client */}

                        <div className="col-md-2">
                            <label className="form-label fw-semibold">
                                Client ID
                            </label>

                            <input
                                type="text"
                                className="form-control"
                                placeholder="Client ID"
                                value={clientId}
                                onChange={handleClient}
                            />
                        </div>

                        {/* Game */}

                        <div className="col-md-2">
                            <label className="form-label fw-semibold">
                                Game
                            </label>

                            <select
                                className="form-select"
                                value={gameName}
                                onChange={handleGame}
                            >
                                <option value="">All Games</option>

                                <option value="aviator">
                                    Aviator
                                </option>

                                <option value="wingo">
                                    Win Go
                                </option>

                                <option value="lucky7">
                                    Lucky7
                                </option>

                                <option value="matka">
                                    Matka
                                </option>

                                <option value="mines">
                                    Mine Game
                                </option>

                                <option value="spinwheel">
                                    Spin Wheel
                                </option>

                                <option value="titli">
                                    12 Tiles
                                </option>

                                <option value="k3">
                                    K3
                                </option>

                                <option value="5d">
                                    5D
                                </option>

                                <option value="ludo">
                                    Ludo
                                </option>

                                <option value="chess">
                                    Chess
                                </option>
                            </select>
                        </div>

                        {/* Status */}

                        <div className="col-md-2">
                            <label className="form-label fw-semibold">
                                Status
                            </label>

                            <select
                                className="form-select"
                                value={status}
                                onChange={handleStatus}
                            >
                                <option value="">All</option>

                                <option value="placed">
                                    Placed
                                </option>

                                <option value="win">
                                    Win
                                </option>

                                <option value="refund">
                                    Refund
                                </option>
                            </select>
                        </div>

                        {/* Callback Status */}

                        <div className="col-md-2">
                            <label className="form-label fw-semibold">
                                Callback
                            </label>

                            <select
                                className="form-select"
                                value={callbackStatus}
                                onChange={handleCallbackStatus}
                            >
                                <option value="">All</option>

                                <option value="success">
                                    Success
                                </option>

                                <option value="failed">
                                    Failed
                                </option>
                            </select>
                        </div>

                        {/* Refresh */}

                        <div className="col-md-1 d-grid">
                            <label className="form-label">
                                &nbsp;
                            </label>

                            <button
                                className="btn btn-primary"
                                onClick={() =>
                                    fetchHistory(
                                        page,
                                        search,
                                        clientId,
                                        gameName,
                                        status,
                                        callbackStatus,
                                        fromDate,
                                        toDate
                                    )
                                }
                            >
                                ↻
                            </button>
                        </div>

                        {/* From */}

                        <div className="col-md-3">
                            <label className="form-label fw-semibold">
                                From Date
                            </label>

                            <input
                                type="date"
                                className="form-control"
                                value={fromDate}
                                onChange={handleFromDate}
                            />
                        </div>

                        {/* To */}

                        <div className="col-md-3">
                            <label className="form-label fw-semibold">
                                To Date
                            </label>

                            <input
                                type="date"
                                className="form-control"
                                value={toDate}
                                onChange={handleToDate}
                            />
                        </div>

                    </div>

                </div>
            </div>

            {/* ==========================================================
    Summary Cards
========================================================== */}

            <div className="row g-3 mb-4">

                <div className="col-md-3">
                    <div className="card border-0 shadow bg-primary text-white">
                        <div className="card-body">
                            <small>Total Callback</small>
                            <h3>{summary.totalCallback}</h3>
                        </div>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="card border-0 shadow bg-success text-white">
                        <div className="card-body">
                            <small>Success</small>
                            <h3>{summary.success}</h3>
                        </div>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="card border-0 shadow bg-danger text-white">
                        <div className="card-body">
                            <small>Failed</small>
                            <h3>{summary.failed}</h3>
                        </div>
                    </div>
                </div>

                <div className="col-md-3">
                    <div
                        className={`card border-0 shadow text-white ${summary.totalProfit >= 0
                                ? "bg-dark"
                                : "bg-danger"
                            }`}
                    >
                        <div className="card-body">
                            <small>Total Profit</small>

                            <h3>
                                ₹
                                {Number(
                                    summary.totalProfit
                                ).toLocaleString()}
                            </h3>
                        </div>
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="card border-0 shadow">
                        <div className="card-body">
                            <small>Total Bet</small>

                            <h3 className="text-primary">
                                ₹
                                {Number(
                                    summary.totalBet
                                ).toLocaleString()}
                            </h3>
                        </div>
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="card border-0 shadow">
                        <div className="card-body">
                            <small>Total Win</small>

                            <h3 className="text-success">
                                ₹
                                {Number(
                                    summary.totalWin
                                ).toLocaleString()}
                            </h3>
                        </div>
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="card border-0 shadow">
                        <div className="card-body">

                            <div className="row text-center">

                                <div className="col-4">
                                    <small>Placed</small>

                                    <h5>
                                        {summary.placed}
                                    </h5>
                                </div>

                                <div className="col-4">
                                    <small>Win</small>

                                    <h5 className="text-success">
                                        {summary.win}
                                    </h5>
                                </div>

                                <div className="col-4">
                                    <small>Refund</small>

                                    <h5 className="text-warning">
                                        {summary.refund}
                                    </h5>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>

            </div>

            {/* ==========================================================
    Game Wise Summary
========================================================== */}

            <div className="card border-0 shadow mb-4">

                <div className="card-header bg-white fw-bold">
                    Game Wise Summary
                </div>

                <div className="table-responsive">

                    <table className="table table-bordered table-hover mb-0">

                        <thead className="table-light">

                            <tr>

                                <th>Game</th>

                                <th>Total Callback</th>

                                <th>Total Bet</th>

                                <th>Total Win</th>

                                <th>Profit</th>

                            </tr>

                        </thead>

                        <tbody>

                            {gameSummary.length > 0 ? (

                                gameSummary.map((game) => (

                                    <tr key={game.game_name}>

                                        <td>{game.game_name}</td>

                                        <td>{game.totalCallback}</td>

                                        <td>
                                            ₹
                                            {Number(
                                                game.totalBet
                                            ).toLocaleString()}
                                        </td>

                                        <td>
                                            ₹
                                            {Number(
                                                game.totalWin
                                            ).toLocaleString()}
                                        </td>

                                        <td
                                            className={
                                                game.totalProfit >= 0
                                                    ? "text-success fw-bold"
                                                    : "text-danger fw-bold"
                                            }
                                        >
                                            ₹
                                            {Number(
                                                game.totalProfit
                                            ).toLocaleString()}
                                        </td>

                                    </tr>

                                ))

                            ) : (

                                <tr>

                                    <td
                                        colSpan="5"
                                        className="text-center"
                                    >
                                        No Data Found
                                    </td>

                                </tr>

                            )}

                        </tbody>

                    </table>

                </div>

            </div>

            {/* Part 3 starts here */}
            {/* ==========================================================
    Callback History Table
========================================================== */}

            <div className="card border-0 shadow">

                <div className="card-header bg-white">

                    <div className="d-flex justify-content-between align-items-center">

                        <h5 className="mb-0">
                            Callback History
                        </h5>

                        <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() =>
                                fetchHistory(
                                    page,
                                    search,
                                    clientId,
                                    gameName,
                                    status,
                                    callbackStatus,
                                    fromDate,
                                    toDate
                                )
                            }
                        >
                            Refresh
                        </button>

                    </div>

                </div>

                <div className="table-responsive">

                    <table className="table table-hover table-bordered align-middle mb-0">

                        <thead className="table-dark">

                            <tr>

                                <th>#</th>

                                <th>Date</th>

                                <th>Phone</th>

                                <th>UID</th>

                                <th>Client ID</th>

                                <th>Game</th>

                                <th>Game ID</th>

                                <th>Bet</th>

                                <th>Win</th>

                                <th>Profit</th>

                                <th>Status</th>

                                <th>Callback</th>

                                <th>Serial No.</th>

                                <th>Payload</th>

                                <th>Response</th>

                            </tr>

                        </thead>

                        <tbody>

                            {loading ? (

                                <tr>

                                    <td
                                        colSpan="15"
                                        className="text-center py-5"
                                    >

                                        <div
                                            className="spinner-border text-primary"
                                            role="status"
                                        />

                                    </td>

                                </tr>

                            ) : data.length === 0 ? (

                                <tr>

                                    <td
                                        colSpan="15"
                                        className="text-center py-5"
                                    >
                                        No Callback History Found
                                    </td>

                                </tr>

                            ) : (

                                data.map((item, index) => (

                                    <tr key={item.id}>

                                        <td>
                                            {(page - 1) * 20 +
                                                index +
                                                1}
                                        </td>

                                        <td
                                            style={{
                                                minWidth: "160px",
                                            }}
                                        >
                                            {new Date(
                                                item.created_at
                                            ).toLocaleString()}
                                        </td>

                                        <td>{item.phone}</td>

                                        <td>{item.uid}</td>

                                        <td>{item.client_id}</td>

                                        <td>

                                            <span className="badge bg-primary">
                                                {item.game_name}
                                            </span>

                                        </td>

                                        <td>{item.game_id}</td>

                                        <td className="text-primary fw-bold">

                                            ₹
                                            {Number(
                                                item.bet_amount
                                            ).toLocaleString()}

                                        </td>

                                        <td className="text-success fw-bold">

                                            ₹
                                            {Number(
                                                item.win_amount
                                            ).toLocaleString()}

                                        </td>

                                        <td
                                            className={
                                                Number(
                                                    item.profit
                                                ) >= 0
                                                    ? "text-success fw-bold"
                                                    : "text-danger fw-bold"
                                            }
                                        >

                                            ₹
                                            {Number(
                                                item.profit
                                            ).toLocaleString()}

                                        </td>

                                        <td>

                                            {statusBadge(
                                                item.status
                                            )}

                                        </td>

                                        <td>

                                            {callbackBadge(
                                                item.callback_status
                                            )}

                                        </td>

                                        <td
                                            style={{
                                                minWidth: "220px",
                                                fontSize: 12,
                                            }}
                                        >
                                            {item.serial_number}
                                        </td>

                                        <td>

                                            <button
                                                className="btn btn-sm btn-info text-white"
                                                onClick={() => {
                                                    setPayloadModal(
                                                        item.payload
                                                    );
                                                    setShowPayload(
                                                        true
                                                    );
                                                }}
                                            >
                                                View
                                            </button>

                                        </td>

                                        <td>

                                            <button
                                                className="btn btn-sm btn-secondary"
                                                onClick={() => {
                                                    setResponseModal(
                                                        item.response
                                                    );
                                                    setShowResponse(
                                                        true
                                                    );
                                                }}
                                            >
                                                View
                                            </button>

                                        </td>

                                    </tr>

                                ))

                            )}

                        </tbody>

                    </table>

                </div>

            </div>

            {/* Part 3B starts here */}
            {/* ==========================================================
    Pagination
========================================================== */}

            <div className="d-flex justify-content-between align-items-center mt-4">

                <button
                    className="btn btn-secondary"
                    disabled={page === 1}
                    onClick={prevPage}
                >
                    Previous
                </button>

                <div className="fw-bold">
                    Page {page} of {totalPages}
                </div>

                <button
                    className="btn btn-secondary"
                    disabled={page === totalPages}
                    onClick={nextPage}
                >
                    Next
                </button>

            </div>

            {/* ==========================================================
    Payload Modal
========================================================== */}

            {showPayload && (
                <>
                    <div
                        className="modal fade show"
                        style={{
                            display: "block",
                            background: "rgba(0,0,0,.5)",
                        }}
                    >
                        <div className="modal-dialog modal-lg modal-dialog-scrollable">

                            <div className="modal-content">

                                <div className="modal-header">

                                    <h5 className="modal-title">
                                        Callback Payload
                                    </h5>

                                    <button
                                        className="btn-close"
                                        onClick={() =>
                                            setShowPayload(false)
                                        }
                                    />

                                </div>

                                <div className="modal-body">

                                    <pre
                                        style={{
                                            fontSize: 13,
                                            whiteSpace: "pre-wrap",
                                            wordBreak: "break-word",
                                        }}
                                    >
                                        {formatJson(payloadModal)}
                                    </pre>

                                </div>

                            </div>

                        </div>
                    </div>

                    <div className="modal-backdrop fade show"></div>
                </>
            )}

            {/* ==========================================================
    Response Modal
========================================================== */}

            {showResponse && (
                <>
                    <div
                        className="modal fade show"
                        style={{
                            display: "block",
                            background: "rgba(0,0,0,.5)",
                        }}
                    >
                        <div className="modal-dialog modal-lg modal-dialog-scrollable">

                            <div className="modal-content">

                                <div className="modal-header">

                                    <h5 className="modal-title">
                                        Callback Response
                                    </h5>

                                    <button
                                        className="btn-close"
                                        onClick={() =>
                                            setShowResponse(false)
                                        }
                                    />

                                </div>

                                <div className="modal-body">

                                    <pre
                                        style={{
                                            fontSize: 13,
                                            whiteSpace: "pre-wrap",
                                            wordBreak: "break-word",
                                        }}
                                    >
                                        {formatJson(responseModal)}
                                    </pre>

                                </div>

                            </div>

                        </div>
                    </div>

                    <div className="modal-backdrop fade show"></div>
                </>
            )}

        </div>
    );
}

